<template>
  <div>
    <base-breadcrumb-bar
      :pageTitle="'Manage Features'"
      :tabItems="tabs"
      :tab.sync="tab"
      :initialTab="tab"
    >
      <template v-slot:filterBlock>
        <feature-filter
          v-for="(e, i) in tabs"
          :keys="i"
          :queryLimit="e.queryLimit"
          :type="e.type"
          :areaFilters.sync="e.search"
          v-if="i == tab"
        />
        <!-- put display none to just hide but to retain data -->

        <v-row> </v-row>
      </template>
    </base-breadcrumb-bar>

    <v-tabs-items v-model="tab">
      <v-tab-item v-for="(e, i) in tabs" :keys="i">
        <feature-section
          v-if="tab == i"
          :queryLimit="e.queryLimit"
          :type="e.type"
          :search="e.search"
        />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import FeatureSection from "@/components/Base/Features/FeatureSection";
import FeatureFilter from "@/components/Base/Features/FeatureFilter";

export default {
  name: "ViewAdmins",
  components: {
    FeatureSection,
    FeatureFilter,
  },
  data() {
    return {
      tabs: [
         {
          text: "Features",
          icon: "fi fi-rr-features",
          queryLimit: { description: "Features" },
          type: "city",
          search: {},
        },
      ],
      tab: 0,
      currentAreas: [],
    };
  },
  apollo: {},
  computed: {},
  methods: {},
  watch: {},
};
</script>
